import { http } from './config/config-receituario'

export default {
  getByCoords(token, lat, lng) {
    return http.get('weather/coords', {
      headers: {
        Authorization: token,
      },
      params: {
        lat,
        lng,
      },
    })
  },
}
